export default __webpack_public_path__ + "static/media/draftbit.b3739e9b.png";